(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["ab-test-collection-product-grid"]) return;
  try {
    
  var clpLayoutControls = (gridLayout) => {
    // Switch clp layout between 2 and 4 grid
    var switchLayoutBtn = document.getElementById("switch-layout");
    var clpGrid = document.querySelector(".clp-grid");
    
    if (gridLayout === "twoColumnLayout") {
      clpGrid.classList.add("grid-layout"); 
      switchLayoutBtn.classList.remove("grid-4");
    }

    $(switchLayoutBtn).unbind().click(function() {
      if (clpGrid.classList.contains("grid-layout")) {
        $(clpGrid).removeClass("grid-layout"); 
      } else {
        $(clpGrid).addClass("grid-layout");
      }
      
      switchLayoutBtn.classList.toggle("grid-4");
    });
  }
  clpLayoutControls("fourColumnLayout");

  // CLP - click to see more description at bottom
  const seeMoreDescBtn = document.querySelector(".see-more-description");
  if(seeMoreDescBtn){
    const collectionWrapper = document.querySelector(".collection-description-wrapper");
    seeMoreDescBtn.addEventListener("click", (e) => {
      e.preventDefault();
      collectionWrapper.classList.add("expanded");
      seeMoreDescBtn.remove();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-size-guide"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
        $("#size_guide_toggler").click(function(){
            $(".clothing-size-guide-section").addClass("open");
            $('body').addClass('scroll-lock');
        });


        $(".clothing-size-guide__close").click(function(){
            $(".clothing-size-guide-section").removeClass("open");
            $('body').removeClass('scroll-lock');
        });

        $('.cm_btn').click(function(){
            $(this).addClass('active');
            $(this).parent().find('.inches_btn').removeClass('active');
            $('.clothing-size-table tr td .size-inch').hide();
            $('.clothing-size-table tr td .size-cm').show();
        })
        $('.inches_btn').click(function(){
            $(this).addClass('active');
            $(this).parent().find('.cm_btn').removeClass('active');
            $('.clothing-size-table tr td .size-inch').show();
            $('.clothing-size-table tr td .size-cm').hide();
        })

        
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video"] && !window.DesignMode) return;
  try {
    
  $('.pause-btn').click(function(){
      $(this).addClass('hide');
      $(this).parent().find('.play-btn').removeClass('hide');
      $(this).parent().find('.play-btn').focus();
      $(this).parents('.video-wrap').find('video').trigger('pause');
  });
  
  $('.play-btn').click(function(){
      $(this).addClass('hide');
      $(this).parent().find('.pause-btn').removeClass('hide');
      $(this).parent().find('.pause-btn').focus();
      $(this).parents('.video-wrap').find('video').trigger('play');
  });
  
  $('.unmute-btn').click(function(){
      $(this).addClass('hide');
      $(this).parent().find('.mute-btn').removeClass('hide');
      $(this).parent().find('.mute-btn').focus();
      $(this).parents('.video-wrap').find('video').prop('muted', false);
      $(this).parents('.video-wrap').addClass('audio-playing');
  });
  
  $('.mute-btn').click(function(){
      $(this).addClass('hide');
      $(this).parent().find('.unmute-btn').removeClass('hide');
      $(this).parent().find('.unmute-btn').focus();
      $(this).parents('.video-wrap').find('video').prop('muted', true);
      $(this).parents('.video-wrap').removeClass('audio-playing');
  });

  /** CHECK ELEMENT VISIBILITY **/
  $.fn.visible = function(partial) {
      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;
    
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop)); 

  };

   /* VIDEO MUTE ON SCROLL */
   $(window).scroll(function(event) {
      var videoSection = $('.video-wrap');
      if (videoSection.visible(true)) {
        $(this).find('video').trigger('play');
        $(this).find('.unmute-btn').addClass('hide');
        $(this).find('.mute-btn').removeClass('hide');
      } else {
        $(this).find('video').prop('muted', true);
        $(this).find('.unmute-btn').removeClass('hide');
        $(this).find('.mute-btn').addClass('hide');
      }

      if (videoSection.visible(true)) {
        $('.video-wrap.audio-playing').find('video').prop('muted', false);
      } else {
        $('.video-wrap.audio-playing').find('video').prop('muted', true);
      }
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    (function () {
    var $frame = $('.fb-frame'); 
    var $wrap  = $frame.parent();
  
    // Call Sly on frame
      $frame.sly({
        horizontal: 1,
        itemNav: 'basic',
        smart: 1,
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        startAt: 0,
        //scrollBar: $wrap.find('.scrollbar'),
        speed: 1000,
        elasticBounds: 1,
        easing: 'easeOutExpo',
        dragHandle: 1,
        dynamicHandle: 1,
        clickBar: 1, 
        cycleBy: null,
  
        // Buttons
        //prevPage: $wrap.find('.arrow-prev'),
        //nextPage: $wrap.find('.arrow-next')
        });
    }());
  
    $(window).resize(function(e) {
      $('.fb-frame').sly('reload');
    }); 
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

    let $parentList = $('#tabs-content div[data-mm-container]');
    $parentList.each((idx, elm) => {
        const id = $(elm).attr('id');
        const $megaMenu = $('.mega-menu-main[data-id]');
        const mmSection = $(`.mega-menu-main[data-id=${id}]`);
        let $tabMenu = $(`#tabs-content #${id}`);
        console.log(mmSection);
        if (mmSection.length > 0 && $tabMenu.length > 0) {
            $tabMenu.append(mmSection.clone());

        }
    });

    // Click function
    $('#tabs-nav li').click(function () {
        $('#tabs-nav li').removeClass('active');
        $(this).addClass('active');
      console.log((this));
        $('.tab-content').hide();
        if ($(this).find('span').length) {
            var activeTab = $(this).find('span').data('id');
            activeTab = activeTab.includes("/") ? '#' + activeTab.split('#')[1] : activeTab;
            $(`${activeTab}`).fadeIn();
            $('#tabs-content .mb-article-frame').sly('reload');
        }
    });

    $('#tabs-nav li:first-child').trigger('click');

    // $(".mb__close .icon.icon-close").click(function () {
    //   console.log("heloo");
    //     $("#GlobaleFreeShippingBannerContainer .mobile-header-main").removeClass("menu-opening");
    // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  $('.filter-blog-by').click(function(){
    if(!this.classList.contains("active")){
      $('.filter-blog-by').removeClass("active");
      $('.filter-blog-by').attr("aria-expanded","false");
      $(this).addClass('active');
      $(this).attr("aria-expanded","true");
      let blogId =  this.id;
      $('.blog-articles').each(function(i,obj){
        if(blogId == obj.getAttribute('data-blog-filter')){
          obj.classList.remove("hidden");
          obj.classList.add("selected");
        } else{
          obj.classList.remove("selected");
          obj.classList.add("hidden");
        }
      });
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  var clpLayoutControls = (gridLayout) => {
    // Switch clp layout between 2 and 4 grid
    var switchLayoutBtn = document.getElementById('switch-layout');
    var clpGrid = document.querySelector('.clp-grid');

    if (gridLayout === 'twoColumnLayout') {
      clpGrid.classList.add('grid-layout');
      switchLayoutBtn.classList.remove('grid-4');
    }

    $(switchLayoutBtn)
      .unbind()
      .click(function () {
        if (clpGrid.classList.contains('grid-layout')) {
          $(clpGrid).removeClass('grid-layout');
        } else {
          $(clpGrid).addClass('grid-layout');
        }

        switchLayoutBtn.classList.toggle('grid-4');
      });

  };
  clpLayoutControls('fourColumnLayout');

  // CLP - click to see more description at bottom
  const seeMoreDescBtn = document.querySelector('.see-more-description');
  if (seeMoreDescBtn) {
    const collectionWrapper = document.querySelector('.collection-description-wrapper');
    seeMoreDescBtn.addEventListener('click', (e) => {
      e.preventDefault();
      collectionWrapper.classList.add('expanded');
      seeMoreDescBtn.remove();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-sidebar-contact"]) return;
  try {
    
    let oldValue = 0
    let newValue = 0
    window.addEventListener('scroll', (e) => {
        newValue = window.pageYOffset;
        if (oldValue < newValue) {
            console.log("Up");
            document.getElementById('sidebar-container').classList.remove('margin-top-sidebar');
        } else if (oldValue > newValue) {
            console.log("Down");
            document.getElementById('sidebar-container').classList.add('margin-top-sidebar');
        }
        oldValue = newValue;
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-sidebar-privacy"]) return;
  try {
    
    let oldValue = 0
    let newValue = 0
    window.addEventListener('scroll', (e) => {
        newValue = window.pageYOffset;
        if (oldValue < newValue) {
            console.log("Up");
            document.getElementById('sidebar-container').classList.remove('margin-top-sidebar');
        } else if (oldValue > newValue) {
            console.log("Down");
            document.getElementById('sidebar-container').classList.add('margin-top-sidebar');
        }
        oldValue = newValue;
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

      

          // slider #2
          const slick_2 = $("#pdp_media_slider");
          slick_2.slick({
            dots: false,
            vertical: true,
            verticalSwiping: false,
            infinite: false,
            slidesToScroll: 3,
            arrows: false,
            asNavFor: '#media-thumbnails'
          });

          $('#media-thumbnails').slick({
            slidesToShow: 15,
            slidesToScroll: 3,
            asNavFor: '#pdp_media_slider',
            dots: false,
            arrows: false,
            infinite: false,
            centerMode: true,
            focusOnSelect: true,
            vertical: true,
            verticalSwiping: true
          });

          
      $('.product__media-wrapper .slick-slide [data-fancybox="pdp-gallery"]').fancybox({
        buttons: [
          "zoom",
          "fullScreen",
          "close"
        ],
        infobar: false,
        toolbar: true,
        baseClass: "pdp-fancy-box",
        btnTpl: {
        arrowLeft:
          '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">' +
          '<line x1="8.70711" y1="12.832" x2="18" y2="22.125" stroke="black" stroke-linecap="round"/>' +
          '<line x1="17.9055" y1="3.7071" x2="8.70632" y2="12.8354" stroke="black" stroke-linecap="round"/>' +
          "</svg>" +
          "</button>",

        arrowRight:
          '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">' +
          '<line x1="17.2929" y1="13.168" x2="7.99997" y2="3.87504" stroke="black" stroke-linecap="round"/>' +
          '<line x1="8.09453" y1="22.2929" x2="17.2937" y2="13.1646" stroke="black" stroke-linecap="round"/>' +
          "</svg>" +
          "</button>"
      },
      onInit : function( instance ) {
        instance.$refs.toolbar.find('.fancybox-zoom').on('click', function() {
          if ( instance.isScaledDown() ) {
            instance.scaleToActual();
          } else {
            instance.scaleToFit();
          }
        });
        }
      });

      
      $('.mobile-product-images [data-fancybox="pdp-gallery"]').fancybox({
        buttons: [
          "close"
        ],
        infobar: false,
        toolbar: true,
        baseClass: "pdp-fancy-box pdp-slider-fancy-box",
      onInit : function( instance ) {
        instance.$refs.toolbar.find('.fancybox-zoom').on('click', function() {
          if ( instance.isScaledDown() ) {
            instance.scaleToActual();
          } else {
            instance.scaleToFit();
          }
        });
        } 
      });


    // Select all links with hashes
     
    $('a.thumbnail-link').on('click focus', function(event) {
      if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
          && 
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            event.preventDefault();
            
            $('html, body').animate({
            
              scrollTop: target.offset().top
              
            }, 500);
          }
        }
        
      });
        
      var lastScrollTop = 0;
      $(window).scroll(function(event){
        var st = $(this).scrollTop();
   
        lastScrollTop = st;
      });
    

      $('.product__media-wrapper [data-fancybox="pdp-gallery"]').fancybox({
        buttons: [
          "zoom",
          "fullScreen",
          "close"
        ],
        infobar: false,
        toolbar: true,
        baseClass: "pdp-fancy-box",
        btnTpl: {
        arrowLeft:
          '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">' +
          '<line x1="8.70711" y1="12.832" x2="18" y2="22.125" stroke="black" stroke-linecap="round"/>' +
          '<line x1="17.9055" y1="3.7071" x2="8.70632" y2="12.8354" stroke="black" stroke-linecap="round"/>' +
          "</svg>" +
          "</button>",

        arrowRight:
          '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">' +
          '<line x1="17.2929" y1="13.168" x2="7.99997" y2="3.87504" stroke="black" stroke-linecap="round"/>' +
          '<line x1="8.09453" y1="22.2929" x2="17.2937" y2="13.1646" stroke="black" stroke-linecap="round"/>' +
          "</svg>" +
          "</button>"
      },
      onInit : function( instance ) {
        instance.$refs.toolbar.find('.fancybox-zoom').on('click', function() {
          if ( instance.isScaledDown() ) {
            instance.scaleToActual();
          } else {
            instance.scaleToFit();
          }
        });
        }
      });

      var notificationCallback = function(data) {
        var msg = '';
        if (data.status == 'OK') {
          $('.error-msg').hide();
          $('.success-msg').show();
          setTimeout(function() { 
            $('.bis-custom-form').removeClass('show-popup');
            $('body').removeClass('popup-open');
          }, 3000);
        } else {
          $('.error-msg').text("Already Registered");

          $('.success-msg').hide();
          $('.error-msg').show();
        }
      }

      $('#notify_button').click(function(e) {
        e.preventDefault();
        var email = $('#notify_email').val(),
            productId = $(this).data('product-id'), 
            variantId = $('.product-form-btn-desktop input[name="id"]').val(); 
  
            var acceptAgreement = document.getElementById("accept_agreement");
            if (acceptAgreement.checked == true) {
              $('.bis-checkbox').removeClass('checkbox-error');
              BIS.create(email, variantId, productId, {accepts_marketing: true}).then(notificationCallback);
            } else {
              $('.bis-checkbox').addClass('checkbox-error');
            }  
      })



  
      $(document).ready(function(){
        $('div[data-oke-reviews-version]').parents('.block-star-rating').show();
  
        $('.color-swatch').click(function(){
            var color = $(this).attr('data-option');
            $('.selected-color').text(color);
        })
  
        if($(window).width() <= 750) {
          $(".pdp-mb-atc").append($(".product-buy_buttons")); 
        }
  
        $(window).resize(function(e) {
          if($(window).width() <= 750) {
            $(".pdp-mb-atc").append($(".product-buy_buttons")); 
          } else {
            $(".product-form-btn-desktop").append($(".product-buy_buttons")); 
          }
        }); 
  
        $(".reviews-toggler").click(function(){
          $(".pdp-reviews-drawer").toggleClass("open");
          $('.product__info-container').hide();
          $("body").toggleClass("mb-scroll-lock");
          $(".section-header").toggleClass("reviews-open");
        });
  
        $(".pdp-reviews-drawer__close p").click(function(){
          $(".pdp-reviews-drawer").removeClass("open");
          $("body").removeClass("mb-scroll-lock");
          $(".section-header").removeClass("reviews-open");
          $('.product__info-container').show();
        });
  
  
  
        $(".text-with-popup-details").click(function(){
          $(".pdp-discription-drawer").toggleClass("open");
          $("body").toggleClass("scroll-lock");
        });
  
        $(".pdp-discription-drawer__close").click(function(){
          $(".pdp-discription-drawer").removeClass("open");
          $("body").removeClass("scroll-lock");
        });
  
  
        $(document).on('click', '.notify-me', function(){
            $('.bis-custom-form').addClass('show-popup');
            $('body').addClass('popup-open');
        })
        
        
  
        $('.general-popup ').click(function(){
            $('.bis-custom-form').removeClass('show-popup');
            $('body').removeClass('popup-open');
        })
  
        $('.general-popup-inner').click(function(e){
         e.stopPropagation();
  
            $('.bis-custom-form').addClass('show-popup');
            $('body').addClass('popup-open');
        })
        $('#close_popup').click(function(e){
          e.stopPropagation();
            $('.bis-custom-form').removeClass('show-popup');
            $('body').removeClass('popup-open');
        })
        $('#bis_popup_close').click(function(e){
           e.stopPropagation();
            $('.bis-custom-form').removeClass('show-popup');
            $('body').removeClass('popup-open');
        })
  
  
  
        
        var badgeSize = $('.pdp-badges ul li').length
        if (badgeSize > 2){
            $('.pdp-badges ul').addClass('comma-separated');
        }
  
    (function () {
      var $frame = $('.mb-images-frame'); 

      var mbImgFrame = new Swiper(".mySwiper", {
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
      });

      $(window).resize(function(e) {
        mbImgFrame.reInit()
      }); 


        }()); 

  
  
        
  
        $('[data-fancybox="pdp-mb-slider-gallery"]').fancybox({
          buttons: [
            "close"
          ],
          infobar: false,
          toolbar: true,
          baseClass: "pdp-fancy-box pdp-slider-fancy-box",
        onInit : function( instance ) {
          instance.$refs.toolbar.find('.fancybox-zoom').on('click', function() {
            if ( instance.isScaledDown() ) {
              instance.scaleToActual();
            } else {
              instance.scaleToFit();
            }
          });
          }
        });
  
        
        
        $('.mobile-product-images [data-fancybox="pdp-gallery"]').fancybox({
          buttons: [
            "close"
          ],
          infobar: false,
          toolbar: true,
          baseClass: "pdp-fancy-box pdp-slider-fancy-box",
        onInit : function( instance ) {
          instance.$refs.toolbar.find('.fancybox-zoom').on('click', function() {
            if ( instance.isScaledDown() ) {
              instance.scaleToActual();
            } else {
              instance.scaleToFit();
            }
          });
          } 
        });
  
        $('.desktop-product-images [data-fancybox="pdp-gallery"]').fancybox({
          buttons: [
            "close"
          ],
          infobar: false,
          toolbar: true,
          baseClass: "pdp-fancy-box pdp-slider-fancy-box",
        onInit : function( instance ) {
          instance.$refs.toolbar.find('.fancybox-zoom').on('click', function() {
            if ( instance.isScaledDown() ) {
              instance.scaleToActual();
            } else {
              instance.scaleToFit();
            }
          });
          }
        });
      });

      setTimeout(function() { 
        const klarnaWrappers = document.querySelectorAll('.shopify-app-block [data-key] > div');

        if (klarnaWrappers) {
          klarnaWrappers.forEach((k) => {
            let style = k.shadowRoot.children[0].getElementsByTagName('style')[0].innerHTML;
            k.shadowRoot.children[0].getElementsByTagName('style')[0].innerHTML += `.container {border: 0;padding: 0;margin-top: 1rem 0;font-family: 'Favorite-Book';opacity: .75;font-size: 12px;}.link {font-family: 'Favorite-Book';font-size: 12px;}</style>`;
          })
        }
      }, 2000);

  
      window.addEventListener('load', (event) => {
        $('#kustomer-ui-sdk-iframe').ready(function(){
          if(window.matchMedia('(max-width: 750px)').matches){
            if ($(window).scrollTop() < 100 ){
              $('#kustomer-ui-sdk-iframe').addClass("hide-away");
            }
          };
        });

      })
  
      let isChatOpen = null
    //   window.addEventListener('load', (event) => {
    //     document.querySelector('#OpenKustomerChat').addEventListener('click', () => {
    //       Kustomer.open();
    //     })
    //     Kustomer.addListener('onOpen', function(){
    //       isChatOpen = true
    //     })
    //     Kustomer.addListener('onClose', function(){
    //       isChatOpen = false
    //     })
    //   })
      // <!-- Hide/Show Kustomer Chat Widget on Scroll -->
      $(document).ready(function(){
        if(window.matchMedia('(max-width: 750px)').matches){
          $(window).scroll(function(event) {
            if (($(window).scrollTop() < 100) && !isChatOpen) {
              $('#kustomer-ui-sdk-iframe').addClass("hide-away"); 
            } else {
              $('#kustomer-ui-sdk-iframe').removeClass("hide-away");
            }
          });
        }
      })

      setTimeout(function() { 
        const klarnaWrappers = document.querySelectorAll('.shopify-app-block [data-key] > div');
        if (klarnaWrappers) {
          klarnaWrappers.forEach((k) => {
            let style = k.shadowRoot.children[0].getElementsByTagName('style')[0].innerHTML;
            k.shadowRoot.children[0].getElementsByTagName('style')[0].innerHTML += `.container {border: 0;padding: 0;margin-top: 1rem 0;font-family: 'Favorite-Book';opacity: .75;font-size: 12px;}.link {font-family: 'Favorite-Book';font-size: 12px;}</style>`;
          })
        }
      }, 2500);



      function addedToCart() {
  fetch(`${window.location.origin}/cart.js`)
  .then(res => res.clone().json().then(data => {
    var cart = {
      total_price: data.total_price/100,
      $value: data.total_price/100,
      total_discount: data.total_discount,
      original_total_price: data.original_total_price/100,
      items: data.items
    }
    if (item !== 'undefined') {
      cart = Object.assign(cart, item)
    }
    klaviyo.push(['track', 'Added to Cart', cart])
  }))
} 
(function (ns, fetch) {
  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    response.then(res => {
      if (`${window.location.origin}/cart/add.js`
      	.includes(res.url)) {
        	addedToCart()
      }
    });
    return response
  }
}(window, window.fetch))
$(document).ajaxComplete(function(event, request, settings){
  if(settings.url == "/cart/add.js"){
      addedToCart()
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  var clpLayoutControls = (gridLayout) => {
    // Switch clp layout between 2 and 4 grid
    var switchLayoutBtn = document.getElementById("switch-layout");
    var prodGrid = document.querySelector("#product-grid");
    
    if (gridLayout == "twoColumnLayout") {
      console.log("set 2 columns layout");
      prodGrid.classList.add("grid-layout"); 
      switchLayoutBtn.classList.remove("grid-4");
    }

    $(switchLayoutBtn).unbind().click(function() {
      console.log("switchLayoutBtn: ", $(".grid-layout"));
      if (prodGrid.classList.contains("grid-layout")) {
        $(prodGrid).removeClass("grid-layout"); 
      } else {
        $(prodGrid).addClass("grid-layout");
      }
      
      switchLayoutBtn.classList.toggle("grid-4");
    });
  }
  clpLayoutControls("fourColumnLayout");

  // Opens up the header search modal when click on `search again` button
  const searchAgainBtn = document.getElementById("search-again");
  searchAgainBtn.addEventListener("click", () => {
    let searchModal = document.querySelectorAll(".header__search details");
    document.body.classList.add("overflow-hidden");
    
    searchModal.forEach(modal => {
      modal.setAttribute("open", "true");
      modal.setAttribute("expanded", "true");
    });
  });


  // Set active state to selected search category and toggles the section
  const searchSubCategories = document.querySelectorAll('.search-categories a');
  searchSubCategories.forEach(category => {
    category.onclick = categoryClick;
  })

  function categoryClick(evt) {
    evt.preventDefault();
    searchSubCategories.forEach(category => {
      category.classList.remove('active');
    })
    evt.target.classList.add('active');
    
    document.querySelectorAll(".search-resource-wrapper").forEach(wrapper => {
      wrapper.classList.add("hidden");
    });

    var selectedSearchCategory = evt.target.getAttribute("data-attr");
    if (selectedSearchCategory == "all") {
      document.querySelectorAll(".search-resource-wrapper").forEach(wrapper => {
        wrapper.classList.remove("hidden");
        wrapper.classList.remove("remove-spaces");
      });
    } else {
      document.getElementById(selectedSearchCategory).classList.remove("hidden");
      document.getElementById(selectedSearchCategory).classList.add("remove-spaces");
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-searchandfilter"]) return;
  try {
    
  var clpLayoutControls = (gridLayout) => {
    // Switch clp layout between 2 and 4 grid
    var switchLayoutBtn = document.getElementById("switch-layout");
    var prodGrid = document.querySelector("#product-grid");
    
    if (gridLayout == "twoColumnLayout") {
      console.log("set 2 columns layout");
      prodGrid.classList.add("grid-layout"); 
      switchLayoutBtn.classList.remove("grid-4");
    }

    $(switchLayoutBtn).unbind().click(function() {
      console.log("switchLayoutBtn: ", $(".grid-layout"));
      if (prodGrid.classList.contains("grid-layout")) {
        $(prodGrid).removeClass("grid-layout"); 
      } else {
        $(prodGrid).addClass("grid-layout");
      }
      
      switchLayoutBtn.classList.toggle("grid-4");
    });

  }
  clpLayoutControls("fourColumnLayout");

  // Opens up the header search modal when click on `search again` button
  const searchAgainBtn = document.getElementById("search-again");
  searchAgainBtn.addEventListener("click", () => {
    let searchModal = document.querySelectorAll(".header__search details");
    document.body.classList.add("overflow-hidden");
    
    searchModal.forEach(modal => {
      modal.setAttribute("open", "true");
      modal.setAttribute("expanded", "true");
    });
  });


  // Set active state to selected search category and toggles the section
  const searchSubCategories = document.querySelectorAll('.search-categories a');
  searchSubCategories.forEach(category => {
    category.onclick = categoryClick;
  })

  function categoryClick(evt) {
    evt.preventDefault();
    searchSubCategories.forEach(category => {
      category.classList.remove('active');
    })
    evt.target.classList.add('active');
    
    document.querySelectorAll(".search-resource-wrapper").forEach(wrapper => {
      wrapper.classList.add("hidden");
    });

    var selectedSearchCategory = evt.target.getAttribute("data-attr");
    if (selectedSearchCategory == "all") {
      document.querySelectorAll(".search-resource-wrapper").forEach(wrapper => {
        wrapper.classList.remove("hidden");
        wrapper.classList.remove("remove-spaces");
      });
    } else {
      document.getElementById(selectedSearchCategory).classList.remove("hidden");
      document.getElementById(selectedSearchCategory).classList.add("remove-spaces");
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-products-tabs"] && !window.DesignMode) return;
  try {
    

$(document).ready(function(){
$('.theme-tabs-nav li:first-child').addClass('active');

$('.theme-tab-content').hide();
$('.theme-tab-content:first').show();

//$('.frame').sly('reload');

// Click function
$('.theme-tabs-nav li').click(function(){
$('.theme-tabs-nav li').removeClass('active');
$(this).addClass('active');
$('.theme-tab-content').hide();

var activeTab = $(this).find('a').attr('href');
$(activeTab).fadeIn();
return false;
});
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-page"] && !window.DesignMode) return;
  try {
    

  $('[data-fancybox]').fancybox({
    touch: false
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-eighth-article-1"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    (function () {
    var $frame = $('.fb-frame'); 
    var $wrap  = $frame.parent();
  
    // Call Sly on frame
      $frame.sly({
        horizontal: 1,
        itemNav: 'basic',
        smart: 1,
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        startAt: 0,
        //scrollBar: $wrap.find('.scrollbar'),
        speed: 1000,
        elasticBounds: 1,
        easing: 'easeOutExpo',
        dragHandle: 1,
        dynamicHandle: 1,
        clickBar: 1, 
        cycleBy: null,
  
        // Buttons
        //prevPage: $wrap.find('.arrow-prev'),
        //nextPage: $wrap.find('.arrow-next')
        });
    }());
  
    $(window).resize(function(e) {
      $('.fb-frame').sly('reload');
    }); 
    var element = $(".sub-categories a.active");
    element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-five-article-1"] && !window.DesignMode) return;
  try {
    
$(document).ready(function () {
$(".pause-btn").click(function () {
      $(this).addClass("hide");
      $(this).parent().find(".play-btn").removeClass("hide");
      $(this).parents(".video-wrap").find("video").trigger("pause");
    });
  
    $(".play-btn").click(function () {
      $(this).addClass("hide");
      $(this).parent().find(".pause-btn").removeClass("hide");
      $(this).parents(".video-wrap").find("video").trigger("play");
    });
  
    $(".unmute-btn").click(function () {
      $(this).addClass("hide");
      $(this).parent().find(".mute-btn").removeClass("hide");
      $(this).parents(".video-wrap").find("video").prop("muted", false);
      $(this).parents(".video-wrap").addClass("audio-playing");
    });
  
    $(".mute-btn").click(function () {
      $(this).addClass("hide");
      $(this).parent().find(".unmute-btn").removeClass("hide");
      $(this).parents(".video-wrap").find("video").prop("muted", true);
      $(this).parents(".video-wrap").removeClass("audio-playing");
    });
  
    /** CHECK ELEMENT VISIBILITY **/
    $.fn.visible = function (partial) {
      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
  
      return compareBottom <= viewBottom && compareTop >= viewTop;
    };
  
    /* VIDEO MUTE ON SCROLL */
    $(window).scroll(function (event) {
      var videoSection = $(".video-wrap");
      if (videoSection.visible(true)) {
      } else {
        $(".video-wrap").find("video").prop("muted", true);
        $(".video-wrap").find("video").trigger("pause");
      }
  
      if (videoSection.visible(true)) {
        $(".video-wrap.audio-playing")
          .find("video")
          .prop("muted", false);
      }
    });
  
    let theVideo = $(".video-wrap").find("video").get(0);
    $(theVideo).on("pause", function (e) {
      $(".play-btn").removeClass("hide");
      $(".pause-btn").addClass("hide");
    });
    $(theVideo).on("play", function (e) {
      $(".play-btn").addClass("hide");
      $(".pause-btn").removeClass("hide");
    });
    });


  if (window.matchMedia("(max-width: 990px)").matches) {
    $(document).ready(function () {
      let vid = document.getElementById("article_main_video");
      vid.pause();
      vid.autoplay = false;
      let playBtn = document.getElementById("mobile_video_play_btn");
  
      //hide video section on fullscreen exit
      var isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      $(document).on ('mozfullscreenchange webkitfullscreenchange fullscreenchange',function(){
          isFullscreen = !isFullscreen;
          if(!isFullscreen){
            vid.pause();
            $(".video-wrap").css("display", "none");
          }
      });
      
      //Hide video on iPhone
      vid.addEventListener('webkitendfullscreen', function (e) { 
        $(".video-wrap").css("display", "none");
      });
      });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-five-article-2"] && !window.DesignMode) return;
  try {
    
    
    //Featured products showing/hiding functionality
    window.addEventListener('load', (event) => {

      //hiding the section
      $(".article_sec_five_type2_container .article_wide_image_container").click(function(){
        $(".custom_featured_products-1").css({
                                                            'visibility' : 'visible',
                                                            'height' : 'auto',
                                                            'padding-top' : '50px',
                                                            'padding-bottom' : '50px'
                                                          });
        $(".custom_featured_products-1").slideDown();  
      })

      //Showing the section
      $(".slider_close_btn_container-1").click(function(){
        $(".custom_featured_products-1").slideUp();  
      })

    }); 


        window.addEventListener('load', (event) => {
      
      (function () {
      var $frame = $('.frame'); 
      var $wrap  = $frame.parent();
    
      // Call Sly on frame
        $frame.sly({
        horizontal: 1,
        itemNav: 'basic',
        smart: 1,
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        startAt: 0,
        //scrollBar: $wrap.find('.scrollbar'),
        speed: 1000,
        elasticBounds: 1,
        easing: 'easeOutExpo',
        dragHandle: 1,
        dynamicHandle: 1,
        clickBar: 1, 
        cycleBy: null,
    
          // Buttons
          // prevPage: $wrap.find('.arrow-prev'),
          // nextPage: $wrap.find('.arrow-next')
          });
      }());
    
      // $(window).resize(function(e) {
      //   $('.frame').sly('reload');
      // }); 

      if (window.matchMedia("(max-width: 990px)").matches) {
        $(".article_sec_five_type2_container .collection").css({
                                                            'visibility' : 'hidden',
                                                            'height' : '0',
                                                            'padding-top' : '0',
                                                            'padding-bottom' : '0'
                                                          });
      } else{
        //hide the featured products module when the document loads 
        $(".article_sec_five_type2_container .collection").css("display","none")
      }

      /* Adapt width of title container to the width of slider */
      $(".custom_featured_products-1 .collection__title").css("width",$(".custom_featured_products-1 .frame ul.slidee").css("width"))
      $(".custom_featured_products-2 .collection__title").css("width",$(".custom_featured_products-2 .frame ul.slidee").css("width"))

    })
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-six-article-2"] && !window.DesignMode) return;
  try {
    
    
    //Featured products showing/hiding functionality
    window.addEventListener('load', (event) => {

      //hiding the section
      $(".two_image_one{{ section.id }}").click(function(){
        if($(".custom_featured_products-2").css("display")=="block"){
          $(".custom_featured_products-2").css("display","none"); 
          $(".custom_featured_products-1").css({
                                                            'visibility' : 'visible',
                                                            'height' : 'auto',
                                                            'padding-top' : '50px',
                                                            'padding-bottom' : '50px'
                                                          });
          $(".custom_featured_products-1").fadeIn();
        } else{
          $(".custom_featured_products-1").css({
                                                            'visibility' : 'visible',
                                                            'height' : 'auto',
                                                            'padding-top' : '50px',
                                                            'padding-bottom' : '50px'
                                                          });
          $(".custom_featured_products-1").slideDown();
        } 
      })
      $(".two_image_two{{ section.id }}").click(function(){
        if($(".custom_featured_products-1").css("display")=="block"){
          $(".custom_featured_products-1").css("display","none");
          $(".custom_featured_products-2").css({
                                                            'visibility' : 'visible',
                                                            'height' : 'auto',
                                                            'padding-top' : '50px',
                                                            'padding-bottom' : '50px'
                                                          });
          $(".custom_featured_products-2").fadeIn();    
        } else{
          $(".custom_featured_products-2").css({
                                                            'visibility' : 'visible',
                                                            'height' : 'auto',
                                                            'padding-top' : '50px',
                                                            'padding-bottom' : '50px'
                                                          });
          $(".custom_featured_products-2").slideDown();  
        }  
      })

      //Showing the section
      $(".slider_close_btn_container-1").click(function(){
        $(".custom_featured_products-1").slideUp();  
      })
      $(".slider_close_btn_container-2").click(function(){
        $(".custom_featured_products-2").slideUp();  
      })

    });

    window.addEventListener('load', (event) => {
      
      (function () {
      var $frame = $('.frame'); 
      var $wrap  = $frame.parent();
    
      // Call Sly on frame
        $frame.sly({
        horizontal: 1,
        itemNav: 'basic',
        smart: 1,
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        startAt: 0,
        //scrollBar: $wrap.find('.scrollbar'),
        speed: 1000,
        elasticBounds: 1,
        easing: 'easeOutExpo',
        dragHandle: 1,
        dynamicHandle: 1,
        clickBar: 1, 
        cycleBy: null,
    
          // Buttons
          // prevPage: $wrap.find('.arrow-prev'),
          // nextPage: $wrap.find('.arrow-next')
          });
      }());
    
      // $(window).resize(function(e) {
      //   $('.frame').sly('reload');
      // }); 
      if (window.matchMedia("(max-width: 990px)").matches) {
        $(".article_sec_seventh_container .collection").css({
                                                            'visibility' : 'hidden',
                                                            'height' : '0',
                                                            'padding-top' : '0',
                                                            'padding-bottom' : '0'
                                                          });
      } else{
        //hide the featured products module when the document loads 
        $(".article_sec_seventh_container .collection").css("display","none")
      }
      /* Adapt width of title container to the width of slider */
      $(".custom_featured_products-1 .collection__title").css("width",$(".custom_featured_products-1 .frame ul.slidee").css("width"))
      $(".custom_featured_products-2 .collection__title").css("width",$(".custom_featured_products-2 .frame ul.slidee").css("width"))
    })
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-two-article-2"] && !window.DesignMode) return;
  try {
    
    //Featured products showing/hiding functionality
    window.addEventListener('load', (event) => {

      //Showing the section
      $(".two_image_one").click(function(){
        if($(".custom_featured_products-2").css("display")=="block"){
          $(".custom_featured_products-2").css("display","none"); 
          $(".custom_featured_products-1").css({
                                                            'visibility' : 'visible',
                                                            'height' : 'auto',
                                                            'padding-top' : '50px',
                                                            'padding-bottom' : '50px'
                                                          });
          $(".custom_featured_products-1").fadeIn();
        } else{
          $(".custom_featured_products-1").css({
                                                            'visibility' : 'visible',
                                                            'height' : 'auto',
                                                            'padding-top' : '50px',
                                                            'padding-bottom' : '50px'
                                                          });
          $(".custom_featured_products-1").slideDown();
        }  
      })
      $(".two_image_two").click(function(){
        if($(".custom_featured_products-1").css("display")=="block"){
          $(".custom_featured_products-1").css("display","none");
          $(".custom_featured_products-2").css({
                                                            'visibility' : 'visible',
                                                            'height' : 'auto',
                                                            'padding-top' : '50px',
                                                            'padding-bottom' : '50px'
                                                          });
          $(".custom_featured_products-2").fadeIn();    
        } else{
          $(".custom_featured_products-2").css({
                                                            'visibility' : 'visible',
                                                            'height' : 'auto',
                                                            'padding-top' : '50px',
                                                            'padding-bottom' : '50px'
                                                          });
          $(".custom_featured_products-2").slideDown();  
        }  
      })

      //Hiding the section
      $(".slider_close_btn_container-1").click(function(){
        $(".custom_featured_products-1").slideUp();  
      })
      $(".slider_close_btn_container-2").click(function(){
        $(".custom_featured_products-2").slideUp();  
      })

    }); 

    window.addEventListener('load', (event) => {
      
      (function () {
      var $frame = $('.frame'); 
      var $wrap  = $frame.parent();
    
      // Call Sly on frame
        $frame.sly({
        horizontal: 1,
        itemNav: 'basic',
        smart: 1,
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        startAt: 0,
        //scrollBar: $wrap.find('.scrollbar'),
        speed: 1000,
        elasticBounds: 1,
        easing: 'easeOutExpo',
        dragHandle: 1,
        dynamicHandle: 1,
        clickBar: 1, 
        cycleBy: null,
    
          // Buttons
          // prevPage: $wrap.find('.arrow-prev'),
          // nextPage: $wrap.find('.arrow-next')
          });
      }());
    
      // $(window).resize(function(e) {
      //   $('.frame').sly('reload');
      // }); 
      //hide the featured products module when the document loads 
      if (window.matchMedia("(max-width: 990px)").matches) {
        $(".article_sec_two_type2_container .collection").css({
                                                            'visibility' : 'hidden',
                                                            'height' : '0',
                                                            'padding-top' : '0',
                                                            'padding-bottom' : '0'
                                                          });
      } else{
        $(".article_sec_two_type2_container .collection").css("display","none")
      }
      /* Adapt width of title container to the width of slider */
      $(".custom_featured_products-1 .collection__title").css("width",$(".custom_featured_products-1 .frame ul.slidee").css("width"))
      $(".custom_featured_products-2 .collection__title").css("width",$(".custom_featured_products-2 .frame ul.slidee").css("width"))
    })
    

  } catch(e) { console.error(e); }
})();
      })();
